'use strict'

import angular from 'angular'

import uiRouter from 'angular-ui-router'

import routing from './myscripts.routes'

import list from './list'
import show from './show'
import add from './add'
import edit from './edit'
import active from './active'
import model from './model'
import addModel from './addModel'

export default angular.module('updateServerApp.myscripts', [uiRouter, list, show, add, edit, active, model, addModel])
  .config(routing)
  .run(function ($rootScope) {
    'ngInject'

    $rootScope.$on('$stateChangeStart', function (event, next, nextParams, current) {
      if (next.name === 'logout' && current && current.name && !current.authenticate) {
        next.referrer = current.name
      }
    })
  })
  .name



// WEBPACK FOOTER //
// ./client/app/myscripts/index.js